import $ from 'jquery'
import { Core } from './core'

export class HashScroll {

  constructor () {
    if (Core.isAdmin()) return

    this.$document = $(document)
    this.$window = $(window)
    this.$body = $('body')
    this.$header = $('header')

    this.$document.ready(this.handleLoadHashScroll.bind(this))
    this.$window.on('hashchange', this.handleChangeHashLocation.bind(this))
    this.$body.on('click', 'a[href*="#"]', this.handleClickLinkHashScroll.bind(this))
  }

  handleClickLinkHashScroll (e) {
    let hashLink = $(e.currentTarget).attr('href')
    hashLink = hashLink ? '#' + hashLink.split('#')[1] : '#';
    if (hashLink.length === 1) return

    // Extract the ID part (without #) and validate/sanitize it
    const hashId = hashLink.substring(1)

    // Check if the ID contains invalid characters for jQuery selector
    // or if it's too complex/malformed (like encoded data)
    if (!hashId || hashId.includes('=') || hashId.includes('#')) {
      // Invalid or malformed hash, ignore it
      return
    }

    // Use getElementById for safer selection (avoids jQuery selector parsing issues)
    const targetElement = document.getElementById(hashId)
    if (!targetElement) return

    e.preventDefault()

    const $item = $(targetElement)
    history.pushState({}, '', hashLink)

    // When mobile menu is open
    if ( Core.isBpLessThan('lg') && this.$header.hasClass('active') ) {

      // Menu state
      this.$header.removeClass('active');
      Core.activeBodyScroll();
      this.$header.find('i.icon-close_1').removeClass('icon-close_1').addClass('icon-burger');

      setTimeout(() => Core.scrollTo($item), 300);
    } else {
      Core.scrollTo($item)
    }
  }

  handleChangeHashLocation () {
    if (window.location.hash !== '' && window.location.hash.length) {
      let $item = $(window.location.hash)

      if ($item.length) {
        Core.scrollTo($item)
      }
    }
  }

  handleLoadHashScroll () {
    let scrollToTab = [
      '.alert[role="alert"]'
    ]

    if (window.location.hash !== '' && window.location.hash.length) {
      scrollToTab.push(location.hash)
    }

    let stopForeach = false

    for (let i = 0; i < scrollToTab.length; i++) {
      let $item = $(scrollToTab[i])

      if ($item.length && !stopForeach) {
        stopForeach = true
        Core.scrollTo($item)
        break
      }
    }
  }
}
